"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayVfxStepArgs = void 0;
const uuid_1 = require("uuid");
const TimeInterval_1 = require("../TimeInterval");
class DelayVfxStepArgs {
    constructor(interval = TimeInterval_1.MillisecondVfxTimeInterval.OneHundred) {
        this.interval = interval;
        this.__typeName = "Delay";
        this.id = (0, uuid_1.v4)();
    }
}
exports.DelayVfxStepArgs = DelayVfxStepArgs;
DelayVfxStepArgs.ms = (ms) => new DelayVfxStepArgs(new TimeInterval_1.MillisecondVfxTimeInterval(ms));
